import { useQuery } from '@tanstack/react-query';
import { QueryKeys } from '~/services/loyalty/constants';
import { createLoyaltyQuery } from '~/services/loyalty/lib';
import { useLoyaltyContext } from '..';
import type { LoyaltyApiError, PointsListResponse } from '~/lib/data-contract/loyalty';
import type { AllowedOptions } from '../allowedQueryOptions';

export const usePointsList = <TData = PointsListResponse>(
    options?: AllowedOptions<PointsListResponse, TData>,
) => {
    const { businessCentralId, translate, trackError } = useLoyaltyContext();

    return useQuery<PointsListResponse, LoyaltyApiError, TData>({
        queryKey: [QueryKeys.POINTS_LIST],
        queryFn: createLoyaltyQuery('GetPointsList', translate, trackError, {
            memberId: businessCentralId,
        }),
        enabled: false,
        refetchOnWindowFocus: false,
        retry: false,
        gcTime: 1000 * 30,
        ...options,
    });
};
